import { Box } from "@mui/material";

import { Service } from "../../../types/service.type";

import PageContentWrapper from "./PageContentWrapper";
import ProgramRequestHeader from "./ProgramRequestHeader";
import ProgramRequestSummary from "./ProgramRequestSummary";

const OwnedProgram = ({ service }: { service: Service }) => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.programContainer}>
        <ProgramRequestHeader service={service} />
        <PageContentWrapper programService={service} />
      </Box>
      <ProgramRequestSummary programService={service} />
    </Box>
  );
};

export default OwnedProgram;

const styles = {
  container: {
    position: "relative",
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    width: "100%",
    gap: "16px",
  },
  programContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: { xs: "100%", md: "calc(100% - 300px)" },
    maxWidth: { lg: "553px" },
    height: "fit-content",
  },
};
